import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { NavLink } from "react-router-dom"

const RetirementPlanCard = ({
  id,
  name,
  type,
  label,
  ownerName,
  employerName,
  match_rate_1,
  match_limit_1,
  match_rate_2,
  match_limit_2
}) => {
  return (
    <Card>
      <Card.Content>
        <Grid style={{ position: "relative", height: "170px" }}>
          <Grid.Row columns={2} verticalAlign="top">
            <Grid.Column>
              <NavLink
                to={`/organize/income+benefits/benefits/${id}/${type.toLowerCase()}`}
                className="navlink"
              >
                <span className="GenericCard__LinkTitle">
                  {label}
                  <Icon name="chevron right" size="small" />
                </span>
                <p className="greyed-text">
                  {employerName && `Sponsored by ${employerName}`}
                </p>
              </NavLink>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="GenericCard__Balance">
                {match_rate_1
                  ? `${match_rate_1}% match up to ${match_limit_1}%`
                  : "No matching program"}
              </p>
              <p className="GenericCard__Balance">
                {match_rate_2
                  ? `${match_rate_2}% match on next ${match_limit_2 -
                      match_limit_1}%`
                  : null}
              </p>
              <p className="greyed-text">{"employer matching"}</p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2} verticalAlign="bottom">
            <Grid.Column>
              <p className="greyed-text">{ownerName}</p>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <p className="greyed-text">Retirement Plan</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  )
}

export default RetirementPlanCard
